import { useState } from "react";
import { Empty } from "antd";

//COMPONENTS
import { Accordion } from "../../../../../../../Components/CustomUi/accordion";
import { ItemPropriedades } from "../../../../../../../services/atividades/GET";

//PROPS
interface Props {
    lista_talhoes: any[];
    data_propriedades: ItemPropriedades[];
}

export const SemAtividade: React.FC<Props> = ({ lista_talhoes, data_propriedades }) => {

    const [open_accordion, setOpen_accordion] = useState<number>(null);

    if ((lista_talhoes ?? []).length === 0) {
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nenhum talhão sem atividade" />;
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {(lista_talhoes ?? []).map((talhao: any, i: number) => (
                <Accordion
                    key={talhao.cod ?? i}
                    label={<div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        textAlign: 'left'
                    }}>
                        <span style={{ fontWeight: 600, margin: 0 }}>{talhao.nome}</span>
                        <span style={{ fontWeight: 600, fontSize: 11, color: 'var(--primary-color)', margin: 0 }}>
                            {data_propriedades.find(p => p.cod === talhao.cod_propriedade)?.nome}
                        </span>
                    </div>}
                    open={talhao.cod === open_accordion}
                    trigger={open_accordion === talhao.cod ? () => { setOpen_accordion(null) } : () => { setOpen_accordion(talhao.cod) }}
                    single
                >
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nenhuma atividade" />
                </Accordion>
            ))}
        </section>
    )
};
